import { Typography } from '@mui/material';
import useGetAppointmentPayments from '../../hooks/appointments/useGetAppointmentPayments';
import { PaymentWithTransfers } from '../../types/payments';
import { Appointment } from '../../interfaces';
import { getGroupedTransfers } from '../../helpers/payments';
import { formatDollarAmount } from '../../utils/global/helper';

interface Props {
  appointment: Appointment;
  payment?: PaymentWithTransfers;
  useSpecStyle?: boolean;
}

function TransferDetailsSummary({ payment, appointment, useSpecStyle }: Props) {
  const { payments, isFetching } = useGetAppointmentPayments(appointment, {
    enabled: !payment,
  });

  const filteredPayments = payment ? [payment] : payments;
  const groupedTransfers = getGroupedTransfers(filteredPayments ?? []);
  const transferCount = (filteredPayments ?? []).flatMap(
    p => p.transfers ?? [],
  ).length;

  if (isFetching || !groupedTransfers.length) return null;

  const totalAmount =
    groupedTransfers.reduce((sum, transfer) => sum + transfer.amount, 0) / 100;

  return (
    <Typography
      variant={useSpecStyle ? undefined : 'body2'}
      color={useSpecStyle ? undefined : 'text.secondary'}
      sx={
        useSpecStyle
          ? {
              fontSize: 'var(--sidebar-font-sm)',
              color: 'var(--sidebar-tertiary)',
            }
          : undefined
      }
      whiteSpace="nowrap">
      {transferCount} transfer
      {transferCount === 1 ? '' : 's'} · {formatDollarAmount(totalAmount)}
    </Typography>
  );
}

export default TransferDetailsSummary;
